var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconGallery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.138,
    height: 21.5,
    viewBox: "0 0 27.138 21.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Image_2",
    "data-name": "Image 2",
    transform: "translate(0.25 0.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7512",
    "data-name": "Path 7512",
    d: "M32.622,17.6H11.817A2.9,2.9,0,0,0,8.9,20.517V35.683A2.9,2.9,0,0,0,11.817,38.6H32.622a2.9,2.9,0,0,0,2.917-2.917V20.517A2.9,2.9,0,0,0,32.622,17.6ZM9.548,35.845l6.028-5.185a.974.974,0,0,1,1.2-.065L21.506,33.9l-4.343,4.051H11.817A2.267,2.267,0,0,1,9.548,35.845Zm23.074,2.106H18.136l7.842-7.324a.984.984,0,0,1,1.134-.13l7.778,4.245v.94A2.255,2.255,0,0,1,32.622,37.951ZM34.89,34,27.4,29.915a1.617,1.617,0,0,0-1.88.227l-3.532,3.305-4.861-3.4a1.606,1.606,0,0,0-1.977.1L9.548,35V20.517a2.255,2.255,0,0,1,2.268-2.268H32.622a2.255,2.255,0,0,1,2.268,2.268Z",
    transform: "translate(-8.9 -17.6)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7513",
    "data-name": "Path 7513",
    d: "M38.423,27.9a3.792,3.792,0,1,0,3.759,3.824v-.032A3.811,3.811,0,0,0,38.423,27.9Zm0,6.935a3.144,3.144,0,1,1,3.111-3.176v.032A3.161,3.161,0,0,1,38.423,34.834Z",
    transform: "translate(-26.27 -24.561)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGallery);
export default __webpack_public_path__ + "static/media/Icon_Gallery.750f3c2c015f0e30b9f773874d300114.svg";
export { ForwardRef as ReactComponent };